import styled from 'styled-components'
import {
  COLORS,
  SPACING,
  BORDER_RADIUS,
  TRANSITIONS,
  TYPOGRAPHY,
  FONT_WEIGHT,
} from '../../../styles/theme'

export const CardContainer = styled.div<{ $isSelected: boolean; $isMultiSelect?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING.lg};
  background: ${(props) => (props.$isSelected ? COLORS.bgSelected : COLORS.bgPrimary)};
  border: 2px solid ${(props) => (props.$isSelected ? COLORS.primary : COLORS.borderCard)};
  border-radius: ${BORDER_RADIUS.lg};
  cursor: pointer;
  transition: ${TRANSITIONS.all};
  min-height: 56px;

  &:hover {
    border-color: ${COLORS.primary};
    box-shadow: 0 2px 8px ${COLORS.focusRing};
  }
`

export const CardLabel = styled.span`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: ${COLORS.textPrimary};
`

export const CheckIndicator = styled.div<{ $isSelected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: ${BORDER_RADIUS.sm};
  border: 2px solid ${(props) => (props.$isSelected ? COLORS.primary : COLORS.borderDarkVar)};
  background: ${(props) => (props.$isSelected ? COLORS.primary : COLORS.bgTransparent)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${TRANSITIONS.fast};
  flex-shrink: 0;
`

export const RadioIndicator = styled.div<{ $isSelected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: ${BORDER_RADIUS.full};
  border: 2px solid ${(props) => (props.$isSelected ? COLORS.primary : COLORS.borderDarkVar)};
  background: ${COLORS.bgTransparent};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${TRANSITIONS.fast};
  flex-shrink: 0;

  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: ${BORDER_RADIUS.full};
    background: ${(props) => (props.$isSelected ? COLORS.primary : COLORS.bgTransparent)};
    transition: ${TRANSITIONS.fast};
  }
`

export const OptionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
`

export const OtherInputContainer = styled.div`
  margin-top: ${SPACING.sm};
  padding-left: ${SPACING.lg};
`
